import { render, staticRenderFns } from "./HeaderOnboardingGuest.vue?vue&type=template&id=63fbf04d"
import script from "./HeaderOnboardingGuest.vue?vue&type=script&lang=js"
export * from "./HeaderOnboardingGuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports